import { router, usePage } from "@inertiajs/react";
import { ReactSVG } from "react-svg";
import star from "@/assets/star.svg";
import { useDispatch } from "react-redux";
import { openModal, setItemSelected } from "@/store/slices/modalSlice";
import { ResultItem, SearchItem } from "@/types";
import { ButtonHTMLAttributes } from "react";


type StarProps = {
    item: ResultItem
    circle?: boolean
    color?: string

} & ButtonHTMLAttributes<HTMLButtonElement>

const Star: React.FC<StarProps> = ({ item, circle, color, ...rest }) => {

    const { locale, isAuth } = usePage().props;

    const dispatch = useDispatch()

    const handleOpenLoginModal = (item: ResultItem) => {
        dispatch(
            setItemSelected({
                id: item.id,
                type: item.modelType,
            }),
        )
        dispatch(openModal("login"));
    }

    return (
        <button title="Wishlist" {...rest} >
            <ReactSVG

                src={star}
                onClick={() =>
                    isAuth === true
                        ? item.isOnWishlist
                            ? router.patch(
                                `/${locale}/wishable/delete`,
                                {
                                    slug: item.slug?.key,
                                    prefix: item.slug?.prefix,
                                },
                                {
                                    preserveScroll: true,
                                    preserveState: true,
                                    onSuccess: () => {
                                        item.isOnWishlist = false;
                                    },
                                },
                            )
                            : router.patch(
                                `/${locale}/wishable/add`,
                                {
                                    slug: item.slug?.key,
                                    prefix: item.slug?.prefix,
                                },
                                {
                                    preserveScroll: true,
                                    preserveState: true,
                                    onSuccess: () => {
                                        item.isOnWishlist = true;
                                    },
                                },
                            )
                        : handleOpenLoginModal(item)
                }
                className={`${circle ? "rounded-full border-black" : 'rounded-md'} min-w-8 transition border-1 hover:cursor-pointer hover:text-yellow-300 hover:border-yellow-300 p-2 ${item.isOnWishlist ? "text-yellow-300 border-yellow-300" : "text-white"}`}
                beforeInjection={(svg) => {
                    svg.setAttribute("style", "width: 21px; height: 21px;");
                    svg.querySelectorAll("path").forEach((path) => {
                        path.setAttribute("fill", item.isOnWishlist ? 'currentColor' : color ? color : "currentColor");
                    });
                }}
            />
        </button>
    );
};

export default Star;
